/* eslint-disable   */
import React, { useState, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import ImageGallery from 'react-image-gallery';
import { authUrl } from '~settings/endpoints';

export default function CommentImageGallery(props) {
  const buildImageUrl = source => authUrl(`/apis/v1/properties/${source}`);

  const renderImageItem = item => (
    <div className="comment-image-gallery__item">
      <p className="comment-image-gallery__item-title">{item.originalTitle}</p>
      <img src={item.original} style={{ maxHeight: '90vh', maxWidth: '100vw' }} />
    </div>
  );

  const getFilesList = () =>
    props.files.map(file => ({
      original: buildImageUrl(file.source),
      originalTitle: file.name,
      renderItem: renderImageItem,
    }));

  const handleGalleryClose = () => {
    props.onClose();
  };

  return (
    <div className="comment-image-gallery">
      <div className="comment-image-gallery__position">
        <button className="comment-image-gallery__close-btn" onClick={handleGalleryClose}>
          <CloseOutlined className="comment-image-gallery__close-icon" />
        </button>
        <ImageGallery
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showThumbnails={false}
          showPlayButton={false}
          items={getFilesList()}
          lazyLoad={true}
        />
      </div>
    </div>
  );
}
